"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

interface LoginLinkWithReturnUrlProps {
  children: React.ReactNode;
  className?: string;
}

export function LoginLinkWithReturnUrl({ children, className }: LoginLinkWithReturnUrlProps) {
  const pathname = usePathname();
  const href = pathname ? `/login?returnUrl=${encodeURIComponent(pathname)}` : "/login";
  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
}
